import dayjs from "dayjs";
export const getNextDayOfWeek = (date: Date, dayOfWeek: number): Date => {
  const resultDate = new Date(date.getTime());

  resultDate.setDate(date.getDate() + ((7 + dayOfWeek - date.getDay()) % 7));

  return resultDate;
};

export const formatMinutesToTime = (minutes: number) => {
  const h = Math.floor(minutes / 60)
    .toString()
    .padStart(2, "0");
  const m = (minutes % 60).toString().padStart(2, "0");
  return `${h}:${m}`;
};
export const parseTimeToMinutes = (time: string): number | null => {
  if (!time) return null;

  const trimmed = time.trim();

  // Format: H:MM or HH:MM
  let match = trimmed.match(/^(\d{1,2}):(\d{1,2})$/);
  if (match) {
    const h = parseInt(match[1], 10);
    const m = parseInt(match[2], 10);
    if (h > 23 || m > 59) return null;
    return h * 60 + m;
  }

  // 3 or 4 digits like 930 or 0930
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 3 || digits.length === 4) {
    const padded = digits.padStart(4, "0");
    const h = parseInt(padded.slice(0, 2), 10);
    const m = parseInt(padded.slice(2, 4), 10);
    if (h > 23 || m > 59) return null;
    return h * 60 + m;
  }

  return null;
};

export function getDurationBetweenTimes(
  startTime: string,
  endTime: string | null
): string {
  const start = dayjs(startTime);
  const end = endTime ? dayjs(endTime) : dayjs(); // Use current time if endTime is null

  const diffInMinutes = end.diff(start, "minute");

  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes} min`;
}

export function formatDistance(distanceInMetres: number): string {
  if (distanceInMetres >= 1000) {
    const km = Math.round(distanceInMetres / 1000);
    return `${km} km`;
  } else {
    const m = Math.round(distanceInMetres);
    return `${m} m`;
  }
}

export const getCurrentDateTimeWithMicroseconds = () => {
  const now = dayjs(); // system local time
  const milliseconds = now.millisecond().toString().padStart(3, "0");
  const microseconds = milliseconds + "000"; // Convert to 6-digit microseconds
  return now.format("YYYY-MM-DDTHH:mm:ss") + `.${microseconds}`;
};
